import { useState } from 'react';

import { Close, KebabMenu } from '@equip.health/ui';

import ConfirmModal from '~/components/common/ConfirmModal';

interface MessageKebabMenuProps {
  messageId: number;
  onRemoveClicked: (messageId: number) => void;
}

const MessageKebabMenu = ({
  messageId,
  onRemoveClicked,
}: MessageKebabMenuProps) => {
  const [isShowConfirmation, setIsShowConfirmation] = useState<boolean>(false);

  const handleOptionClicked = (optionId: number) => {
    if (optionId === 1) {
      setIsShowConfirmation(true);
    }
  };

  const messageKebabMenuItems: KebabMenuItem[] = [
    {
      color: 'red',
      icon: <Close fill="red" height="16px" />,
      label: 'Remove from channel',
      onClick: () => handleOptionClicked(1),
    },
  ];
  return (
    <>
      <KebabMenu
        ariaLabel="Message options"
        id={String(messageId)}
        options={messageKebabMenuItems}
      />
      <ConfirmModal
        body="Are you sure you want to proceed? This action can’t be undone."
        cancelLabel="Cancel"
        confirmLabel="Delete"
        confirmVariant="accent.critical"
        isOpen={isShowConfirmation}
        onClose={() => setIsShowConfirmation(false)}
        onConfirm={() => onRemoveClicked(messageId)}
        title="Remove from channel"
      />
    </>
  );
};

export default MessageKebabMenu;
